import type { RouteType } from "~/lib/api";
import { cn } from "~/lib/utils";

interface RouteTypeIconProps {
  routeType: RouteType;
  className?: string;
}

/**
 * Route type icons for hiking trails:
 * - Loop: Circular arrow
 * - Out and back: Bidirectional arrow
 * - Point to point: A→B arrow
 */
export function RouteTypeIcon({ routeType, className }: RouteTypeIconProps) {
  const classes = cn("size-4 shrink-0", className);

  switch (routeType) {
    case "loop":
      // Organic loop with knockout dot at trailhead
      return (
        <svg viewBox="0 0 16 16" fill="none" className={classes}>
          <mask id="loop-mask">
            <rect width="16" height="16" fill="white" />
            <circle cx="2.5" cy="8" r="3.5" fill="black" />
          </mask>
          <ellipse cx="8" cy="8" rx="6" ry="5" stroke="currentColor" strokeWidth="1.5" mask="url(#loop-mask)" />
          <circle cx="2.5" cy="8" r="2" fill="currentColor" />
        </svg>
      );
    case "out-and-back":
      return (
        <svg viewBox="0 0 16 16" fill="none" className={classes}>
          <path
            d="M3 8H13M3 8L5.5 5.5M3 8L5.5 10.5M13 8L10.5 5.5M13 8L10.5 10.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "point-to-point":
      return (
        <svg viewBox="0 0 16 16" fill="none" className={classes}>
          <circle cx="3" cy="8" r="2" fill="currentColor" />
          <path
            d="M6 8H13M13 8L10.5 5.5M13 8L10.5 10.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
}
